import React from "react";
import "./ProgressBox.scss";

interface Props {
  color: string;
  text: string;
  value: number;
  valueSum: number;
}
const ProgressBox: React.FC<Props> = ({ color, text, value, valueSum }) => {
  return (
    <div className="progress-bar-parent">
      <div className="content-parent">
        <p>{text}</p>
        <p style={{ color: color }}>{value}</p>
      </div>
      <div title={`${Math.round(value/valueSum*100)}%`} className="progress-bar-chart-parent">
        <div style={{width:`${value/valueSum*100}%`,backgroundColor:color}} className="progress-bar-chart"></div>
      </div>
    </div>
  );
};

export default ProgressBox;
